import { ActionIcon, Button, Group } from '@mantine/core';
import { IconArrowRight, type IconAlarm as TablerIcon } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales/index';
import { Link } from 'react-router-dom';

interface ActivityItemprops
  extends React.PropsWithChildren<{
    url: string;
    highlight?: boolean;
    Icon: React.ComponentType<React.ComponentProps<typeof TablerIcon>>;
  }> {}

export const ActivityItem = ({ url, highlight, Icon, children }: ActivityItemprops) => {
  const { t } = useTranslation();
  return (
    <Group justify="space-between">
      <Group gap="space2">
        <ActionIcon
          component="span"
          style={{ pointerEvents: 'none' }}
          color="gray.6"
          variant="subtle"
        >
          <Icon size={24} stroke={1.5} />
        </ActionIcon>
        {children}
      </Group>
      <Link to={url}>
        <Button
          justify="space-between"
          variant={highlight ? 'filled' : 'default'}
          bd={highlight ? 'none' : '1px solid gray.4'}
          leftSection={<IconArrowRight size={18} />}
        >
          {t(i18nKeys.PROCESS)}
        </Button>
      </Link>
    </Group>
  );
};
